import styled from 'styled-components';
import { colors } from 'themes/colors';

export const Wrapper = styled.div`
  width: 100%;
  font-size: 10px;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 100;
  border-bottom: 1px solid #eeeeee;

  > nav {
    display: flex;
    padding: 30px;
    justify-content: space-between;
    align-items: center;
    max-width: 1400px;
    margin: auto;
    width: 100%;
    @media (max-width: 1200px) {
      padding: 15px 30px;
    }
    @media (max-width: 600px) {
      padding: 15px 20px;
    }

    img {
      width: 155px;
      @media (max-width: 1200px) {
        width: 100px;
      }
    }
  }
`;

export const DesktopNav = styled.section`
  display: flex;
  align-items: center;
  @media (max-width: 1000px) {
    display: none;
  }

  ul li {
    list-style: none;
    display: inline-block;
  }
  ul > li  button {
    padding: 10px 20px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    @media (max-width: 1200px) {
      padding: 10px 15px;
      font-size: 14px;
    }
  }
  
  button {
    padding: 10px 25px;
    border: 1px solid #202530;
    border-radius: 3px;
    margin: 0 5px;
    text-transform: uppercase;
    font-size: 16px;
    cursor: pointer;
    font-weight: 700;
    @media (max-width: 1200px) {
      font-size: 14px;
    }

    &.filled {
      color: #fff;
      background: ${colors.primary};
      border: 1px solid ${colors.primary};
    }
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const NavIcon = styled.div`
  display: none;
  @media (max-width: 1000px) {
    display: flex;
    align-items: center;
  }
  button {
    padding: 5px 15px;
    border: 1px solid #202530;
    border-radius: 3px;
    width: 100%;
    text-transform: uppercase;
    font-size: 14px;
    cursor: pointer;
    font-weight: 700;
    margin-right: 15px;

    &.filled {
      color: #fff;
      background: ${colors.primary};
      border: 1px solid ${colors.primary};
    }
    &:hover {
      opacity: 0.8;
    }
  }
  > i {
    font-size: 22px;
  }
`;

export const MobileNav = styled.section`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 300px;
  z-index: 200;
  background: #fff;
  padding: 50px 30px;
  display: none;
  transform: translate3d(305px, 0, 0);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  transition: 0.2s all ease;
  @media (max-width: 1000px) {
    display: block;
  }
  &.active {
    transform: translate3d(0, 0, 0);
  }
  ul {
    margin-bottom: 20px;
  }
  ul li {
    list-style: none;
  }
  ul > li button {
    padding: 10px 0;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
  }
  > button {
    padding: 10px 0;
    border: 1px solid #202530;
    border-radius: 3px;
    width: 100%;
    text-transform: uppercase;
    font-size: 16px;
    cursor: pointer;
    font-weight: 700;
    margin-bottom: 10px;

    &.filled {
      color: #fff;
      background: ${colors.primary};
      border: 1px solid ${colors.primary};
    }
    &:hover {
      opacity: 0.8;
    }
  }
  .close-btn {
    font-size: 22px;
    cursor: pointer;
    position: absolute;
    top: 25px;
    right: 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/NavigationRelative/styles.js